import { render } from "./VThumb.vue?vue&type=template&id=9096f4f6"
import script from "./VThumb.vue?vue&type=script&lang=js"
export * from "./VThumb.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__